// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/css/" + chunkId + "." + {"89":"b7caefb8","175":"387bf6d5","238":"58125d5b","250":"0ffbd6f9","318":"14ab55ec","353":"69fd4249","878":"a526869e"}[chunkId] + ".css";
};